export default function FAQSection() {
  const faqs = [
    {
      question: '蚕丝被可以水洗吗？',
      answer: '不建议水洗。蚕丝蛋白纤维遇水会膨胀，容易导致缩水、变硬和失去光泽。专业干洗是保养蚕丝被最安全的方式。',
    },
    {
      question: '羽绒被干洗后保暖性会下降吗？',
      answer: '专业羽绒干洗不会影响保暖性。使用温和溶剂和低温烘干，保留羽绒天然油脂，羽绒被洗后依然蓬松保暖。不规范干洗过度脱脂才会导致保暖性下降。',
    },
    {
      question: '美女被干洗一次多少钱？',
      answer: '根据被子尺寸和面料工艺，美女被专业干洗价格一般在200-500元之间。具体价格建议咨询门店获取精确报价。',
    },
    {
      question: '干洗后的被子需要晾晒吗？',
      answer: '专业干洗后的被子已完全干燥，无需额外晾晒。取出后可在室内通风处放置2-3小时散除残余溶剂气味即可使用。',
    },
    {
      question: '被芯多久干洗一次比较合适？',
      answer: '一般建议每1-2年干洗一次。蚕丝被和羽绒被可2年一次，日常使用被套能有效延长干洗周期。出现异味或污渍应提前安排。',
    },
    {
      question: '你们提供上门取送服务吗？',
      answer: '是的，我们提供免费上门取送服务。覆盖上海市大部分区域，您可以通过电话400-888-6666预约，或直接到店咨询。',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="container-main">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto leading-relaxed">
            关于被芯干洗护理，您可能关心的问题都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5"
            >
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 font-heading">
                <i className="ri-question-answer-line text-accent-500 mr-2"></i>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}